import { NgModule } from '@angular/core';
import { SharedModule } from '@shared';
import { RouteRoutingModule } from './routes-routing.module';
// components
import { UserLoginComponent } from './passport/login/login.component';
import { TeacherComponent } from './teacher/teacher.component';
import { AccountSettingsComponent } from './teacher/account-settings/account-settings.component';
import {
    PerfectScrollbarModule,
    PerfectScrollbarConfigInterface,
    PERFECT_SCROLLBAR_CONFIG,
} from 'ngx-perfect-scrollbar';
import { BaseComponent } from './teacher/account-settings/base/base.component';
import { SafetyComponent } from './teacher/account-settings/safety/safety.component';
import { UserRegisterComponent } from './passport/register/register.component';
import { UserLockComponent } from './passport/lock/lock.component';
import { CallbackComponent } from './callback/callback.component';
import { UserRegisterResultComponent } from './passport/register-result/register-result.component';
import { SuccesspageComponent } from './teacher/components/successpage/successpage.component';

const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
    suppressScrollY: true,
};

const COMPONENTS = [
    UserLoginComponent,
    TeacherComponent,
    UserRegisterComponent,
    UserLockComponent,
    CallbackComponent,
    UserRegisterResultComponent,
];

@NgModule({
    imports: [SharedModule, RouteRoutingModule, PerfectScrollbarModule],
    declarations: [...COMPONENTS, AccountSettingsComponent, BaseComponent, SafetyComponent, SuccesspageComponent],
    providers: [
        {
            provide: PERFECT_SCROLLBAR_CONFIG,
            useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG,
        },
    ],
})
export class RoutesModule { }
